module.exports = __webpack_public_path__ + "88020e2d21eca772762071c963559e2f.jpg";